import "./AuthGate.css";

const AuthGate = ({ auth, children, title = "Line Control Login" }) => {
  if (!auth?.authChecked) {
    return (
      <div className="auth-gate">
        <div className="login-card">
          <h1>Checking session...</h1>
        </div>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="auth-gate">
        <form className="login-card" onSubmit={auth.loginSubmitHandler}>
          <h1>{title}</h1>
          <input
            type="text"
            placeholder="Username"
            value={auth.loginUsername}
            onChange={(event) => auth.setLoginUsername(event.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={auth.loginPassword}
            onChange={(event) => auth.setLoginPassword(event.target.value)}
          />
          {auth.loginError && (
            <div className="login-error">{auth.loginError}</div>
          )}
          <button type="submit" disabled={auth.loginLoading}>
            {auth.loginLoading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    );
  }

  return children;
};

export default AuthGate;
